import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const updateAutoReporting: UseCase<AuthRepository, 'updateAutoReporting'> = repository => {
  return async updateAutoReporting => {
    await repository.updateAutoReporting(updateAutoReporting)
  }
}
